/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";

import StyledText from "ae-base/Base/StyledText";
import InputContainer from "../Inputs/Layout/InputContainer";

import { useResources } from "@aetonix/hooks";

export default function OutputNotification(props) {
	const { localize, localizeFrom } = useResources();
	const isATouchAway = props.isATouchAway;
	const schema = props.schema;
	const data = props.data;

	let text = data;

	if (schema.localization) {
		const localizeArgs = (typeof data === "object") ? data : {
			"_": "" + data
		};
		text = localizeFrom(schema.localization, ".", localizeArgs);
	} else if (schema.description) {
		text = localize(schema.description) || schema.description;
	}
	if (isATouchAway) {
		return (
			<InputContainer style={props.style}>
				<StyledText light contrast={props.contrast}>{text}</StyledText>
			</InputContainer>
		);
	} else {
		return (
			<InputContainer style={props.style}>
				<StyledText contrast={props.contrast}>{text}</StyledText>
			</InputContainer>
		);
	}
}